import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { LandingPage } from './components/pages/landingPage';
import { SettingsProvider } from './stateManagement/SettingsContext';
import { Faq } from './components/pages/Faq';
import { AdminPage } from './components/pages/AdminPage';
import { ContactUsPage } from './components/pages/ContactUsPage';
import { PlayerHubPage } from './components/pages/PlayerHubPage';
import { TicketPage } from './components/pages/TicketPage';
import { Section } from './components/pages/Section';
import { ProtectedRoute } from './routes/ProtectedRoute';
import './i18n';
import { LoginPage } from './components/pages/Login';
import { PrivacyPolicyHS } from './components/pages/privacyPolicy';
import { NotFound } from './components/pages/NotFound';
import { IframeGuard } from './components/pages/IframeGuard';
import { NewsDetail } from './components/pages/NewsDetail';
import { PageTracker } from './Analytics/PageTracker';
import { LayoutWithGA } from './components/templates/gaLayout';
import { OneTrustInitializer } from './consentManagement/ontrustInitialiser';
import { Forbidden } from './components/pages/Forbidden';
import { ToastRouteGuard } from './components/atoms/ToastGuard';

export const App: React.FC = () => {
  return (
    <Router>
      <PageTracker />
      <ToastRouteGuard />
      <Routes>
        {/* Public routes */}
        <Route path="/helpshift/privacy-policy" element={<PrivacyPolicyHS />} />
        <Route path="/login/*" element={<LoginPage />} />
        <Route path="/forbidden" element={<Forbidden />} />

        <Route
          path="/admin"
          element={
            <IframeGuard>
              <SettingsProvider>
                <AdminPage />
              </SettingsProvider>
            </IframeGuard>
          }
        />

        {/* Protected routes */}
        <Route
          element={
            <ProtectedRoute>
              <SettingsProvider>
                <OneTrustInitializer />
                <LayoutWithGA>
                  <Outlet />
                </LayoutWithGA>
              </SettingsProvider>
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<LandingPage />} />
          <Route path="/article/*" element={<Faq />} />
          <Route path="/sections/*" element={<Section />} />
          <Route path="/playerhub" element={<PlayerHubPage />} />
          <Route path="/tickethistory/*" element={<TicketPage />} />
          <Route path="/contactUs" element={<ContactUsPage />} />
          <Route path="/news/*" element={<NewsDetail />} />
        </Route>

        {/* Catch all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};
